import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_FILTERS} from "./actionTypes"

import {
  getFiltersFail,
  getFiltersSuccess,
} from "./actions"

//Include Helper File with needed methods
import { getFilters } from "../../helpers/logbook_helper"

function* fetchFilters({payload: uId}) {
  console.log('fetch filters', uId);
  try {
    const response = yield call(getFilters, uId)
    yield put(getFiltersSuccess(response.data))
  } catch (error) {
    yield put(getFiltersFail(error))
  }
}


// function* onApplyFilterProperty({ payload: property }) {
//   try {
//     const response = yield call(applyFilterProperty, property)
//     yield put(applyFilterPropertySuccess(response))
//   } catch (error) {
//     yield put(applyFilterPropertyFail(error))
//   }
// }


// function* onApplyFilterBlock({ payload: block }) {
//   console.log('onAppleBlockFilter', block)
//   try {
//     const response = yield call(applyFilterBlock, block)
//     yield put(applyFilterBlockSuccess(response))
//   } catch (error) {
//     yield put(applyFilterBlockFail(error))
//   }
// }

function* filtersSaga() {
  yield takeEvery(GET_FILTERS, fetchFilters)
  // yield takeEvery(APPLY_FILTER_PROPERTY, onApplyFilterProperty)
  // yield takeEvery(APPLY_FILTER_BLOCK, onApplyFilterBlock)
}

export default filtersSaga;




// function* fetchUserProfile() {
//   try {
//     const response = yield call(getUserProfile)
//     yield put(getUserProfileSuccess(response))
//   } catch (error) {
//     yield put(getUserProfileFail(error))
//   }
// }

// function* onUpdateUser({ payload: user }) {
//   try {
//     const response = yield call(updateUser, user)
//     yield put(updateUserSuccess(response))
//   } catch (error) {
//     yield put(updateUserFail(error))
//   }
// }

// function* onDeleteUser({ payload: user }) {
//   try {
//     const response = yield call(deleteUser, user)
//     yield put(deleteUserSuccess(response))
//   } catch (error) {
//     yield put(deleteUserFail(error))
//   }
// }